export const normalizeValue = (value: string): string => {
  return value.toLowerCase().trim()
}
